module.exports = __webpack_public_path__ + "img/illustration-example.22dfcab.png";